import { Field } from "@base-ui/react/field";
import { TooltipIcon } from "../tooltip-icon";

interface FieldLabelProps {
  htmlFor?: string;
  label: string;
  required?: boolean;
  tooltip?: string;
}

/**
 * Internal label row for form fields.
 * Renders label text, optional required asterisk, and optional tooltip icon.
 * Not exported from the package — consume via form field components.
 */
function FieldLabel({ htmlFor, label, required, tooltip }: FieldLabelProps) {
  return (
    <div className="flex items-center justify-between mb-(--spacing-4)">
      <Field.Label
        htmlFor={htmlFor}
        className="flex items-center gap-(--spacing-2) text-(length:--font-size-body-medium) leading-(--font-line-height-20) font-(number:--font-weight-semibold) text-input-text-default"
      >
        {label}
        {required && (
          <span aria-hidden="true" className="text-input-required">
            *
          </span>
        )}
      </Field.Label>
      {tooltip && <TooltipIcon label={tooltip} size="xs" />}
    </div>
  );
}

export { FieldLabel };
export type { FieldLabelProps };
